var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c("div", {
    staticClass: "cascader"
  }, [_vm.initSuccess ? _vm._t("default", function () {
    return [_c("Cascader", {
      attrs: {
        disabled: _vm.isDisable,
        clearable: _vm.isClear,
        data: _vm.addressList,
        placeholder: "请选择地址",
        "element-id": _vm.id,
        transfer: ""
      },
      on: {
        "on-visible-change": _vm.changeVisible,
        "on-change": _vm.change
      },
      model: {
        value: _vm.currValue,
        callback: function callback($$v) {
          _vm.currValue = $$v;
        },
        expression: "currValue"
      }
    })];
  }) : _vm._e()], 2);
};

var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };